import * as marietta from '../..';
import { MonicaObject } from '.';
import { SVGSprite } from '../flash/display';
import { BUILDING_TYPE_MANSION } from '../Constants';

export default class Beam extends MonicaObject {
  _defaultRoomSetting: marietta.webcad.collection.RoomConfigCollection;

  nuriView: SVGElement;

  guideView: SVGElement;

  wallView: SVGElement;

  lockView: SVGElement;

  wallGuideList: marietta.webcad.item.parts.WallGuide[];

  wallObjList: marietta.webcad.item.parts.Wall[];

  /**
   * リドロー
   */
  reCreateImage = () => {
    // 削除する
    this.nuriView.remove();
    this.wallView.remove();
    this.guideView.remove();
    this.createImage();
  };

  /**
   * ビューの作成
   */
  createImage() {
    // カラーが設定されていなければデフォルトカラーの設定
    this.itemInfo.color = '#666666';
    this.itemInfo.designColor = '#FFFFFF';

    let viewObj: Element;
    if (!this.spt) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    } else {
      viewObj = this.spt.element;
    }
    viewObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(this.itemInfo.dotList));
    viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);

    // 塗り
    this.nuriView = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.nuriView.setAttribute('fill', this.itemInfo.color);
    this.nuriView.setAttribute('fill-opacity', '0');
    this.nuriView.setAttribute('stroke', this.itemInfo.color);
    this.nuriView.setAttribute('stroke-width', '1');
    this.nuriView.setAttribute('stroke-dasharray', '2.0251,2.0251');
    const path = marietta.core.Point.distance(this.itemInfo.dotList[this.itemInfo.dotList.length - 1].point, this.itemInfo.dotList[0].point) === 0 ? this.itemInfo.dotList : [...this.itemInfo.dotList, this.itemInfo.dotList[0]];
    this.nuriView.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(path));
    this.nuriView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}_nuri`);
    viewObj.appendChild(this.nuriView);
    // 壁
    this.wallObjList = [];
    this.wallGuideList = [];

    this.wallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.wallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}wallGroup`);
    let wall: marietta.webcad.item.parts.Wall;

    let guide: marietta.webcad.item.parts.WallGuide;
    this.guideView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.guideView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}beamGuide`);
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
        // 生成
        wall = new marietta.webcad.item.parts.Wall(i, this.wallView, this.itemInfo.dotList[i], i === this.itemInfo.dotList.length - 1 ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1]);
        wall.wallType = 0;

        let gpt: marietta.core.Point[] = [];
        if (i === this.itemInfo.dotList.length - 1) {
          gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[i].point, this.itemInfo.dotList[0].point], 20);
        } else {
          gpt = marietta.webcad.util.WebCADUtil.createPolygonLine([this.itemInfo.dotList[i].point, this.itemInfo.dotList[i + 1].point], 20);
        }
        guide = new marietta.webcad.item.parts.WallGuide(this.guideView, i, { line: '#00069e', text: '#00069e' });
        guide.parentObj = this;
        if (gpt && gpt.length > 1) {
          guide.firstDot = gpt[0].clone();
          guide.secondDot = gpt[1].clone();
        }
        guide.parentObj = this;
        this.wallGuideList.push(guide);
        wall.parentObjInfo = this.itemInfo;
        this.wallObjList.push(wall);
      }
    }
    viewObj.appendChild(this.guideView);
    if (!this.spt) {
      this.spt = new SVGSprite(viewObj);
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();
    }
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem !== this) this.showHideWallGuide(false);
  }

  updateWallGuide() {
    this.wallGuideList.forEach((wall: marietta.webcad.item.parts.WallGuide) => {
      wall.updateTransforms();
    });
  }

  showHideWallGuide(value: boolean) {
    if (value) this.guideView.style.display = 'block';
    else this.guideView.style.display = 'none';
  }

  /**
   * 現行のTransform
   */
  getCurrentTransform() {
    let retTransform = '';
    retTransform += `translate( ${this.itemInfo.x}, ${this.itemInfo.y} ) `;
    retTransform += `rotate( ${this.itemInfo.rotation} ) `;
    return retTransform;
  }

  /**
   * グリッドに吸い付く
   * */
  snapToGrid = () => {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    this.itemInfo.x = Math.round(this.itemInfo.x / snapUnit) * snapUnit;
    this.itemInfo.y = Math.round(this.itemInfo.y / snapUnit) * snapUnit;
    this.updateTransforms();

    // カレントの更新
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
  };

  /**
   * 頂点情報の回転
   */
  rotateDots(value: number): void {
    const r: number = ((value % 360) / 180) * Math.PI;
    let p1: marietta.core.Point;
    let xx: number;
    let yy: number;

    for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
      p1 = this.itemInfo.dotList[i].point;
      xx = p1.x * Math.cos(r) - p1.y * Math.sin(r);
      yy = p1.x * Math.sin(r) + p1.y * Math.cos(r);
      this.itemInfo.dotList[i].x = xx;
      this.itemInfo.dotList[i].y = yy;
    }

    this.reCreateImage();
  }

  /**
   * ドットを反転する
   */
  flipDots(): void {
    let i: number;

    // 左上が原点になるように、コンバートしておく
    // Ｘ座標をマイナスにする
    let minX: number;
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x *= -1;
      if (this.itemInfo.dotList[i].x < minX || minX === undefined || minX === null) minX = this.itemInfo.dotList[i].x;
    }

    // 左上原点になるよう修正
    for (i = 0; i < this.itemInfo.dotList.length; i += 1) {
      this.itemInfo.dotList[i].x += 0 - minX;
    }
    this.itemInfo.x -= minX;

    this.reCreateImage();
  }

  highlight = (status: boolean = true) => {
    this.showHideWallGuide(status);
    if (status) this.nuriView.setAttribute('fill', 'url(#diagonalFill)');
    else this.nuriView.setAttribute('fill', this.itemInfo.color);
  };

  /**
   * ドラッグ可能か
   */
  public isCapableOfMove(): boolean {
    if (!super.isCapableOfMove()) return false;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) return false;
    return true;
  }
  /**
   *
   * @param newDistance
   * @param index
   */

  updateItemWithInput(newDistance: number, index: number): void {
    if (this.itemInfo.lock) return;
    const wall = marietta.webcad.control.parts.RoomMovePickerWall.wall as marietta.webcad.item.parts.Wall;
    const startDot = wall.startDot.point;
    const endDot = wall.endDot.point;
    const distInPix = marietta.webcad.util.WebCADUtil.convertMMToPix(newDistance);

    let adjacent = [];
    const obj = this.wallObjList.find((w: marietta.webcad.item.parts.Wall) => w.index === index);
    const wallDistance = marietta.core.Point.distance(obj.startDot.point, obj.endDot.point);
    const diffDistance = wallDistance - distInPix;

    const obj2 = this.wallObjList.find((w: marietta.webcad.item.parts.Wall) => (marietta.core.Point.distance(w.startDot.point, startDot) < 0.001 && marietta.core.Point.distance(w.endDot.point, endDot) < 0.001) || (marietta.core.Point.distance(w.startDot.point, endDot) < 0.001 && marietta.core.Point.distance(w.endDot.point, startDot) < 0.001));

    adjacent = marietta.webcad.util.WebCADUtil.findAdjascentWalls(obj2.startDot.point, obj2.endDot.point, this.wallObjList);

    if (adjacent.length > 0) {
      for (let i = 0; i < this.wallObjList.length; i += 1) {
        for (let j = 0; j < adjacent.length; j += 1) {
          if (this.wallObjList[i].index === adjacent[j].index) {
            let dot1 = null;
            let dot2 = null;
            const originDist = marietta.core.Point.distance(adjacent[j].startDot.point, adjacent[j].endDot.point);
            if (marietta.core.Point.distance(adjacent[j].startDot.point, startDot) < 0.001) {
              dot1 = diffDistance > 0 ? marietta.webcad.util.WebCADUtil.findPointAlongLine(startDot, adjacent[j].endDot.point, diffDistance) : marietta.webcad.util.WebCADUtil.findPointAlongLine(adjacent[j].endDot.point, startDot, originDist - diffDistance);
            } else if (marietta.core.Point.distance(adjacent[j].endDot.point, startDot) < 0.001) {
              dot2 = diffDistance > 0 ? marietta.webcad.util.WebCADUtil.findPointAlongLine(startDot, adjacent[j].startDot.point, diffDistance) : marietta.webcad.util.WebCADUtil.findPointAlongLine(adjacent[j].startDot.point, startDot, originDist - diffDistance);
            } else if (marietta.core.Point.distance(adjacent[j].startDot.point, endDot) < 0.001) {
              dot1 = diffDistance > 0 ? marietta.webcad.util.WebCADUtil.findPointAlongLine(endDot, adjacent[j].endDot.point, diffDistance) : marietta.webcad.util.WebCADUtil.findPointAlongLine(adjacent[j].endDot.point, endDot, originDist - diffDistance);
            } else if (marietta.core.Point.distance(adjacent[j].endDot.point, endDot) < 0.001) {
              dot2 = diffDistance > 0 ? marietta.webcad.util.WebCADUtil.findPointAlongLine(endDot, adjacent[j].startDot.point, diffDistance) : marietta.webcad.util.WebCADUtil.findPointAlongLine(adjacent[j].startDot.point, endDot, originDist - diffDistance);
            }
            if (dot1) {
              const dot = dot1.clone();
              this.itemInfo.dotList[this.wallObjList[i].index].x = dot.x;
              this.itemInfo.dotList[this.wallObjList[i].index].y = dot.y;
            } else if (dot2) {
              const dot = dot2.clone();
              const ind = this.wallObjList[i].index < this.itemInfo.dotList.length - 1 ? this.wallObjList[i].index + 1 : 0;
              this.itemInfo.dotList[ind].x = dot.x;
              this.itemInfo.dotList[ind].y = dot.y;
            }
          }
        }
      }
    }

    this.reCreateImage();
    if (marietta.webcad.WebCADGlobal.itemManager.currentItem != null && marietta.webcad.WebCADGlobal.itemManager.currentItem !== undefined) {
      const { currentItem } = marietta.webcad.WebCADGlobal.itemManager;
      marietta.webcad.WebCADGlobal.itemManager.currentItem = currentItem;
    }
    marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  }

  public getAdjacentList = (index:number) => {
    const wallList = this.wallGuideList;
    const adjascent = { wallTextList: [], wall: { wall: null }, rooms: [] };
    adjascent.wall.wall = this.wallObjList[index];
    if (index === 0) {
      adjascent.wallTextList.push(wallList[index + 1]);
      adjascent.wallTextList.push(wallList[wallList.length - 1]);
    } else if (index === wallList.length - 1) {
      adjascent.wallTextList.push(wallList[index - 1]);
      adjascent.wallTextList.push(wallList[0]);
    } else {
      adjascent.wallTextList.push(wallList[index - 1]);
      adjascent.wallTextList.push(wallList[index + 1]);
    }
    return adjascent;
  };
}
